import React, { useContext, useEffect, useState } from 'react'
import '../css/customerRequestForm.css'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useImmer } from 'use-immer';
import moment from 'moment-timezone';
import GlobalContext from '../GlobalContext';
import GoodCheck from './GoodCheck';
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import NACweblogo from '../img/logonacweb.png'
import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import {it, de, fr, enUS} from 'date-fns/locale'; // Sostituisci con la tua lingua preferita
import 'react-datepicker/dist/react-datepicker.css';


registerLocale('it-IT', it); // Sostituisci con il tuo codice lingua
registerLocale('de-DE', de);
registerLocale('fr-FR', fr);
registerLocale('en-US', enUS);
setDefaultLocale('it-IT'); // Imposta la lingua predefinita

const languageOptions = [
    { label: 'Italiano', value: 'it-IT' },
    { label: 'Deutsch', value: 'de-DE' },
    { label: 'Français', value: 'fr-FR' },
    { label: 'English', value: 'en-US' },
]
const text = {
    'it-IT': {
        title: 'Nuova prenotazione',
        select_language: 'Seleziona lingua',
        date_apt: 'Data in cui vuole l\'appuntamento:',
        select_none: '*Alcune date non saranno selezionabili per via delle chiusure',
        time_desription: '*Non è possibile richiedere appuntamenti a più di 2 mesi di distanza',
        type_apt: 'Selezionare tipo di appuntamento:',
        name: 'Nome:',
        surname: 'Cognome:',
        telephone: 'Numero di telefono:',
        mail: 'Email:',
        sede_apt: 'Sede in cui vuole l\'appuntamento:',
        pp: 'Accetti la privacy policy?',
        request_impossible: 'Impossibile inviare la richiesta',
        correct: 'Correggere i seguenti errori:',
        request_succ: 'Richiesta inviata con successo!',
        conf: 'La richiesta è stata inviata con successo,',
        conf2: 'verrà ricontattato per confermare o annullare l\'appuntamento',
        imp: 'Impossibile inviare la richiesta',
        errore: 'Errore generico, riprovare più tardi',
        date_hour: 'Impostare una data ed un\'ora valide',
        category: 'Seleziona una categoria',
        correct_error: 'Per favore correggi gli errori nei campi',
        privacy: 'Accetta l\'informativa sulla privacy',
        note: 'Note per l\'appuntamento',
        notee: 'Note:',
        select_date: 'Seleziona data',
        title_pp: 'Privacy Policy',
        description_pp: ` 1 - Info di contatto <br />
        NACweb snc<br />
        Via Lugano 1<br />
        6500 Bellinzona<br />
        Svizzera<br />
        info@nacweb.ch<br />


        2 - Dati raccolti<br />
        I dati che vengono raccolti sono esclusivamente quelli inseriti dall'utente sulla pagina, ovvero:<br />
        - Nome<br />
        - Cognome<br />
        - Numero di telefono<br />
        - Data e ora in cui si vuole richiedere l'appuntamento<br />
        - La sede presso la quale si sta richiedendo l'appuntamento<br />

        Tutti i dati vengono raccolti tramite il form alla pagina https://agenda.nacplan.ch/customer_request_form e inviati tramite il pulsante di conferma.<br />
        Tutti i dati raccolti sono a puro scopo di erogazione del servizio di prenotazione presso le attività che usufruiscono del software, non sono previsti
        utilizzi a fini di marketing o analisi di mercato, ne' tantomeno per stipulare un qualunque tipo di accordo tra le parti.<br />


        3 - Base legale del trattamento<br />
        Il trattamento dei dati personali è basato sull'esecuzione di un contratto. L'utente fornisce volontariamente i propri dati personali attraverso
        il form di prenotazione al fine di usufruire del servizio di prenotazione presso le attività che utilizzano il software fornito da NACweb snc.<br />
        Il trattamento di tali dati è strettamente necessario per consentire la corretta erogazione del servizio richiesto dall'utente.<br />

        Il conferimento dei dati è volontario, ma necessario per l'utilizzo del servizio di prenotazione.<br />
        In caso di mancato conferimento dei dati richiesti, potrebbe non essere possibile completare la prenotazione.<br />

        Gli interessati possono revocare il consenso in qualsiasi momento, ferma restando la legalità del trattamento basato sul consenso prima della revoca.<br />
        La revoca del consenso potrebbe comportare l'impossibilità di utilizzare il servizio di prenotazione.<br />


        4 - Cookies e Tecnologie Simili<br />
        Non viene conservato alcun tipo di cookie o tecnologie di tracciamento su qualunque pagina del sito.<br />


        5 - Conservazione dei dati<br />
        I dati inseriti vengono conservati fino a che il cliente che li riceverà non li eliminerà dalla sua istanza del software.<br />
        I dati vengono inviati ad un server e potranno essere letti dall'utente che utilizza l'account dell'attività presso la quale sarà attivo il software,
        a quel punto potrà conservarli, leggerli, utilizzarli o eliminarli a suo piacimento.<br />


        6 - Diritti degli utenti<br />
        L'utente che invia i dati non sarà più in grado di accedere ai propri dati in autonomia, ne' tantomeno di modificarli.<br />
        In caso di inserimento di dati errati o sensibili inseriti per errore potrà esercitare il diritto di eliminazione dei propri dati contattando l'attività
        presso la quale ha inviato la prenotazione, tramite metodi che possono variare a seconda dell'attività in questione, oppure, in caso questo non sia possibile,
        contattando NACweb snc tramite i metodi sopraindicati e richiedendo l'eliminazione dei tali.<br />


        7 - Sicurezza dei dati<br />
        Coloro che conservano i dati inviati dall'utente saranno sempre impegnati a mantenere la sicurezza massima per evitare le minacce emergenti.<br />
        In caso di una violazione della sicurezza dei dati che potrebbe compromettere la privacy, gli utenti verranno notificati secondo quanto richiesto
        dalle leggi vigenti.<br />
        l'accesso al database è limitato agli operatori di sistema di NACweb che accederanno ai dati solo in caso di necessità ed ai dipendenti dell'azienda
        presso cui viene fatta la prenotazione.<br />
        Tutti i dati sono tenuti all'interno di un database crittografato.<br />


        8 - Trasferimenti Internazionali<br />
        I dati vengono inviati direttamente al server di proprietà di IONOS Group SE (Elgendorfer Straße 57, 56410 Montabaur, Germany) collocato in Spagna.<br />


        9 - Modifiche alla Privacy Policy<br />
        La presente privacy policy potrà subire modifiche future, tali modifiche non verranno comunicate direttamente agli utenti.<br />
        Verrà sempre indicata la data di ultima modifica del presente documento.<br />

        Ultima modifica: 11/01/2024<br />

        Per domande o reclami riguardanti la privacy:<br />

        info@nacweb.ch<br />`

    },
    'de-DE': {

        title: 'Neue Buchung',
        select_language: 'Sprache auswählen',
        date_apt: 'Datum, an dem Sie den Termin wünschen:',
        select_none: '*Einige Termine sind aufgrund von Schließungen nicht wählbar',
        time_desription: '*Termine, die mehr als 2 Monate auseinander liegen, können nicht angefragt werden',
        type_apt: 'Wählen Sie die Art des Termins:',
        name: 'Vorname:',
        surname: 'Nachname:',
        telephone: 'Telefonnummer:',
        mail: 'Email:',
        sede_apt: 'Ort, an dem Sie den Termin wünschen:',
        pp: 'Akzeptieren Sie die Datenschutzrichtlinien?',
        request_impossible: 'Anfrage konnte nicht gesendet werden',
        correct: 'Korrigiere folgende Fehler:',
        request_succ: 'Anfrage erfolgreich gesendet',
        conf: "Die Anfrage wurde erfolgreich gesendet,",
        conf2: "Sie werden kontaktiert, um den Termin zu bestätigen oder abzusagen",
        imp: 'Anfrage konnte nicht gesendet werden',
        errore: 'Allgemeiner Fehler, bitte versuchen Sie es später erneut',
        date_hour: 'Stellen Sie ein gültiges Datum und eine Uhrzeit ein',
        category: 'Wählen Sie eine Kategorie aus',
        correct_error: 'Bitte korrigieren Sie die Fehler in den Feldern',
        privacy: 'Akzeptieren Sie die Datenschutzerklärung',
        note: 'Notizen zum Termin',
        notee: 'Notiz:',
        select_date: 'Datum auswählen',
        title_pp: 'Datenschutzrichtlinie',
        description_pp: `1 - Kontaktdaten <br />
    NACweb snc <br />
    Via Lugano 1 <br />
    6500 Bellinzona <br />
    Schweiz <br />
    info@nacweb.ch <br />

    2 - Gesammelte Daten <br />
    Die gesammelten Daten sind ausschließlich diejenigen, die der Benutzer auf der Seite eingibt, nämlich: <br />
    - Vorname <br />
    - Nachname <br />
    - Telefonnummer <br />
    - Datum und Uhrzeit für die Terminanfrage <br />
    - Der Ort, für den die Terminanfrage gestellt wird <br />

    Alle Daten werden über das Formular auf der Seite https://agenda.nacplan.ch/customer_request_form gesammelt und über die Bestätigungsschaltfläche gesendet. <br />
    Alle gesammelten Daten dienen ausschließlich dazu, den Reservierungsdienst für Unternehmen bereitzustellen, die die bereitgestellte Software nutzen. Es sind keine Marketing- oder Marktforschungszwecke vorgesehen, noch irgendwelche Vereinbarungen zwischen den Parteien. <br />
}


3 - Rechtliche Grundlage der Datenverarbeitung <br />
Die Verarbeitung personenbezogener Daten basiert auf der Erfüllung eines Vertrags. Der Benutzer gibt freiwillig seine persönlichen Daten über das Reservierungsformular preis, um den Reservierungsdienst bei Unternehmen in Anspruch zu nehmen, die die von NACweb snc bereitgestellte Software nutzen. Die Verarbeitung dieser Daten ist unbedingt erforderlich, um die ordnungsgemäße Erbringung des vom Benutzer angeforderten Dienstes zu ermöglichen. <br />

Die Bereitstellung der Daten erfolgt freiwillig, ist jedoch für die Nutzung des Reservierungsdienstes erforderlich. Bei Nichtangabe der angeforderten Daten könnte es nicht möglich sein, die Reservierung abzuschließen. <br />

Betroffene Personen können ihre Einwilligung jederzeit widerrufen, wobei die Rechtmäßigkeit der auf Einwilligung basierenden Verarbeitung vor dem Widerruf unberührt bleibt. Der Widerruf der Einwilligung könnte dazu führen, dass die Nutzung des Reservierungsdienstes nicht möglich ist. <br />


4 - Cookies und ähnliche Technologien <br />
Es werden keine Cookies oder Tracking-Technologien auf irgendwelchen Seiten der Website gespeichert. <br />


        5 - Datenspeicherung <br />
        Die eingegebenen Daten werden so lange aufbewahrt, bis der Kunde, der sie empfängt, sie aus seiner Softwareinstanz löscht. Die Daten werden an einen Server gesendet und können vom Benutzer, der das Konto des Unternehmens nutzt, bei dem die Software aktiv ist, gelesen, gespeichert, verwendet oder gelöscht werden, wie es ihm beliebt. <br />


        6 - Rechte der Benutzer <br />
        Der Benutzer, der Daten sendet, wird nicht mehr in der Lage sein, selbständig auf seine Daten zuzugreifen, geschweige denn sie zu ändern. <br />
        Im Falle der versehentlichen Eingabe von falschen oder sensiblen Daten kann das Recht auf Löschung der eigenen Daten ausgeübt werden, indem man das Unternehmen kontaktiert, an das die Reservierung gesendet wurde. Die Methoden können je nach Unternehmen variieren. Wenn dies nicht möglich ist, kann der Benutzer NACweb snc über die oben genannten Methoden kontaktieren und die Löschung der Daten beantragen. <br />    


        7 - 7 - Datensicherheit <br />
        Diejenigen, die die vom Benutzer gesendeten Daten aufbewahren, werden sich stets bemühen, maximale Sicherheit zu gewährleisten, um aufkommende Bedrohungen zu vermeiden. <br />
        Im Falle einer Verletzung der Datensicherheit, die die Privatsphäre gefährden könnte, werden die Benutzer gemäß den geltenden Gesetzen benachrichtigt. Der Zugang zur Datenbank ist auf die Systembetreiber von NACweb beschränkt, die nur bei Bedarf auf die Daten zugreifen, sowie auf die Mitarbeiter des Unternehmens, bei dem die Reservierung vorgenommen wird. Alle Daten werden innerhalb einer verschlüsselten Datenbank aufbewahrt. <br />


        8 - 8 - Internationale Datenübertragungen <br />
        Die Daten werden direkt an den Server von IONOS Group SE (Elgendorfer Straße 57, 56410 Montabaur, Deutschland) gesendet, der sich in Spanien befindet. <br />

        9 - 9 - Änderungen an der Datenschutzrichtlinie <br />
        Die vorliegende Datenschutzrichtlinie kann in Zukunft Änderungen unterliegen. Diese Änderungen werden nicht direkt an die Benutzer kommuniziert. Das Datum der letzten Aktualisierung dieses Dokuments wird immer angegeben. <br />
        
        Letzte Aktualisierung: 11.01.2024 <br />
    
        Für Fragen oder Beschwerden bezüglich des Datenschutzes: <br />
    
        info@nacweb.ch <br />`
    },
    'fr-FR': {
        title: 'Nouvelle réservation',
        select_language: 'Sélectionner la langue',
        date_apt: 'Date à laquelle vous souhaitez le rendez-vous :',
        select_none: '*Certaines dates ne seront pas sélectionnables en raison de fermetures',//Certaines dates ne pourront pas être sélectionnées en raison de fermetures,
        time_desription: '*Il n\'est pas possible de demander des rendez-vous à plus de 2 mois d\'intervalle',
        type_apt: 'Sélectionner le type de rendez-vous :',
        name: 'Prénom :',
        surname: 'Nom de famille :',
        telephone: 'Numéro de téléphone :',
        mail: 'Email:',
        sede_apt: 'Lieu où vous souhaitez le rendez-vous :',
        pp: 'Acceptez-vous la politique de confidentialité ?',
        request_impossible: 'Impossible d\'envoyer la demande',
        correct: 'Corrigez les erreurs suivantes :',
        request_succ: 'Demande envoyée avec succès',
        "conf": "La demande a été envoyée avec succès,",
  "conf2": "vous serez recontacté pour confirmer ou annuler le rendez-vous",
        imp: 'Impossible d\'envoyer la demande',
        errore: 'Erreur générale, veuillez réessayer plus tard',
        date_hour: 'Définissez une date et une heure valides',
        category: 'Sélectionnez une catégorie',
        correct_error: 'Veuillez corriger les erreurs dans les champs',
        privacy: 'Acceptez la politique de confidentialité',
        note: 'notes de nomination',
        notee: 'Notes:',
        select_date: 'Sélectionner la date',
        title_pp: 'politique de confidentialité',
        description_pp: `1 - Informations de contact <br />
            NACweb snc <br />
            Via Lugano 1 <br />
            6500 Bellinzone <br />
            Suisse <br />
            info@nacweb.ch <br />
            
            2 - Données collectées <br />
    Les données collectées sont exclusivement celles saisies par l'utilisateur sur la page, à savoir : <br />
    - Prénom <br />
    - Nom de famille <br />
    - Numéro de téléphone <br />
    - Date et heure souhaitées pour la demande de rendez-vous <br />
    - Lieu pour lequel la demande de rendez-vous est faite <br />

    Toutes les données sont collectées via le formulaire sur la page https://agenda.nacplan.ch/customer_request_form et envoyées via le bouton de confirmation. <br />
    Toutes les données collectées ont pour seul but de fournir le service de réservation aux entreprises utilisant le logiciel. Aucune utilisation à des fins de marketing ou d'analyse de marché n'est prévue, et aucun accord de quelque nature que ce soit entre les parties. <br />

    3 - Base légale du traitement <br />
    Le traitement des données personnelles est basé sur l'exécution d'un contrat. L'utilisateur fournit volontairement ses données personnelles via le formulaire de réservation afin de bénéficier du service de réservation auprès des entreprises utilisant le logiciel fourni par NACweb snc. <br />
    Le traitement de ces données est strictement nécessaire pour permettre la fourniture correcte du service demandé par l'utilisateur. <br />

    La fourniture des données est volontaire mais nécessaire pour utiliser le service de réservation. En cas de non-fourniture des données requises, il pourrait ne pas être possible de finaliser la réservation. <br />

    Les personnes concernées peuvent révoquer leur consentement à tout moment, tout en préservant la légalité du traitement basé sur le consentement avant la révocation. La révocation du consentement pourrait entraîner l'impossibilité d'utiliser le service de réservation. <br />
            
    4 - Cookies et technologies similaires <br />
    Aucun type de cookie ou de technologie de suivi n'est stocké sur aucune page du site. <br />

    5 - Conservation des données <br />
    Les données saisies sont conservées jusqu'à ce que le client les supprime de son instance logicielle. Les données sont envoyées à un serveur et peuvent être lues par l'utilisateur utilisant le compte de l'entreprise où le logiciel est actif, à ce moment-là, il peut les conserver, les lire, les utiliser ou les supprimer à sa guise. <br />

    6 - Droits des utilisateurs <br />
    L'utilisateur qui envoie les données ne pourra plus y accéder de manière autonome, ni les modifier. <br />
    En cas de saisie de données incorrectes ou sensibles par erreur, l'utilisateur peut exercer son droit de suppression de ses données en contactant l'entreprise où il a envoyé la réservation, par des méthodes pouvant varier en fonction de l'entreprise concernée, ou, si cela n'est pas possible, en contactant NACweb snc via les méthodes susmentionnées et en demandant la suppression de ces données. <br />

    7 - Sécurité des données <br />
    Ceux qui conservent les données envoyées par l'utilisateur s'engagent toujours à maintenir la sécurité maximale pour éviter les menaces émergentes. <br />
    En cas de violation de la sécurité des données pouvant compromettre la confidentialité, les utilisateurs seront informés conformément aux exigences légales en vigueur. <br />
    L'accès à la base de données est limité aux opérateurs système de NACweb qui accéderont aux données uniquement en cas de nécessité et aux employés de l'entreprise où la réservation est effectuée. <br />
    Toutes les données sont stockées dans une base de données cryptée. <br />

    8 - Transferts internationaux <br />
    Les données sont envoyées directement au serveur appartenant à IONOS Group SE (Elgendorfer Straße 57, 56410 Montabaur, Allemagne) situé en Espagne. <br />

    9 - Modifications de la politique de confidentialité <br />
    La présente politique de confidentialité peut faire l'objet de modifications futures, ces modifications ne seront pas communiquées directement aux utilisateurs. La date de la dernière modification du présent document sera toujours indiquée. <br />
    
    Dernière modification : 11/01/2024 <br />

    Pour des questions ou des réclamations concernant la confidentialité : <br />

            info@nacweb.ch <br /> `

    },
    'en-US': {
        title: 'New Booking',
        select_language: 'Select Language',
        date_apt: 'Date for the appointment:',
        select_none: '*Some dates will not be selectable due to closures',
        time_desription: '*Appointments cannot be requested more than 2 months apart',
        type_apt: 'Select type of appointment:',
        name: 'Name:',
        surname: 'Surname:',
        telephone: 'Phone number:',
        mail: 'Email:',
        sede_apt: 'Location for the appointment:',
        pp: 'Do you accept the privacy policy?',
        request_impossible: 'Unable to send the request',
        correct: 'Correct the following errors:',
        request_succ: 'Request sent successfully',
        "conf": "The request has been sent successfully,",
        "conf2": "you will be contacted to confirm or cancel the appointment",
        imp: 'Unable to send the request',
        errore: 'Generic error, please try again later',
        date_hour: 'Set a valid date and time',
        category: 'Select a category',
        correct_error: 'Please correct the errors in the fields',
        privacy: 'Accept the privacy policy',
        note: 'Appointment notes',
        notee: 'Note:',
        select_date: 'Select date',
        title_pp: 'Privacy Policy',
        description_pp: `1 - Contact Information <br />
            NACweb snc <br />
            Via Lugano 1 <br />
            6500 Bellinzona <br />
            Switzerland <br />
            info@nacweb.ch <br />
            
            2 - Data Collected <br />
    The data collected is exclusively that entered by the user on the page, namely: <br />
    - Name <br />
    - Surname <br />
    - Telephone number <br />
    - Date and time for the appointment <br />
    - The location where the appointment is being requested <br />

    All data is collected through the form on the page https://agenda.nacplan.ch/customer_request_form and sent via the confirmation button. <br />
    All collected data is for the sole purpose of providing the reservation service to businesses using the software; there are no intended uses for marketing or market analysis, nor for entering into any agreements between the parties. <br />

    3 - Legal Basis for Data Processing <br />
    The processing of personal data is based on the execution of a contract. The user voluntarily provides their personal data through
    the reservation form in order to avail themselves of the reservation service provided by businesses using the software supplied by NACweb snc. <br />
    The processing of such data is strictly necessary to enable the correct provision of the service requested by the user. <br />

    Providing the data is voluntary but necessary for the use of the reservation service. <br />
    In case of failure to provide the required data, it may not be possible to complete the reservation. <br />

    Individuals can revoke their consent at any time, without affecting the lawfulness of the processing based on consent before its withdrawal. <br />
    Revoking consent may result in the inability to use the reservation service. <br />

    4 - Cookies and Similar Technologies <br />
    No type of cookie or tracking technology is stored on any page of the website. <br />

    5 - Data Retention <br />
    The entered data is stored until the customer who receives them deletes them from their software instance. <br />
    The data is sent to a server and can be read by the user using the account of the business where the software is active,
    at which point they can choose to keep, read, use, or delete them at their discretion. <br />

    6 - User Rights <br />
    The user who submits the data will no longer be able to access their data independently, nor modify them. <br />
    In case of entering incorrect or sensitive data by mistake, they can exercise the right to delete their data by contacting the business
    to which they submitted the reservation, through methods that may vary depending on the specific business, or, if this is not possible,
    by contacting NACweb snc through the aforementioned methods and requesting the deletion of such data. <br />

    7 - Data Security <br />
    Those who store user-submitted data will always strive to maintain the highest security to prevent emerging threats. <br />
    In case of a data security breach that could compromise privacy, users will be notified as required by current laws. <br />
    Access to the database is limited to NACweb system operators who will access the data only when necessary and to employees of the company
    where the reservation is made. <br />
    All data is kept within an encrypted database. <br />

    8 - International Transfers <br />
    The data is sent directly to the server owned by IONOS Group SE (Elgendorfer Straße 57, 56410 Montabaur, Germany) located in Spain. <br />

    9 - Privacy Policy Changes <br />
    This privacy policy may undergo future changes; however, these changes will not be communicated directly to users. <br />
    The date of the last modification to this document will always be indicated. <br />
    Last modified: 11/01/2024 <br />
    For questions or complaints regarding privacy: <br />
    info@nacweb.ch <br />   `
    },

}
const defaultValues={
    name: '',
    surname: '',
    prefix: '41',
    number: '',
    email: '',
    dateTime: undefined,
    notes: '',
}
const defaultCheckValues={
    check: {
        name: (v) => { return v.length > 0 && v.length < 50 },
        surname: (v) => { return v.length > 0 && v.length < 50 },
        prefix: (v) => { return v.length > 0 && v.length <= 4 },
        number: (v) => { v = trim(v); return v.length > 7 && v.length <= 10 },
        email: (v) => { return (v && v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) || v=='' },
        dateTime: (v) => { return v },
        notes: (v) => { return v.length < 500 },
    },
    good: {
        name: true,
        surname: true,
        prefix: true,
        number: true,
        email: true,
        dateTime: true,
        notes: true,
    }
}
// const theme = createTheme({
//     typography: {
//         htmlFontSize: '2vmax', // Imposta l'unità di misura desiderata per la dimensione del testo
//     },
//     overrides: {
//         MuiInput: {
//             root: {
//                 padding: '2%', // Imposta il padding generale
//             },
//         },
//     },
// });

const trim = (str) => {
    return str.split(' ').join('');
}

const CustomerRequestForm = () => {
    const animatedComponents = makeAnimated();
    const globalContext = useContext(GlobalContext)

    const [language, setLanguage] = useState({ label: 'Italiano', value: 'it-IT' })
    const [shopOptions, setShopOptions] = useState([])
    const [categoryOptions, setCategoryOptions] = useState([])
    const [selectedShop, setSelectedShop] = useState(undefined)
    const [selectedCategory, setSelectedCategory] = useState(undefined)
    const [values, setValues] = useImmer(defaultValues)
    const [checkValues, setCheckValues] = useImmer(defaultCheckValues)
    const [closures, setClosures] = useImmer({})
    const [privacyAccepted, setPrivacyAccepted] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)
    const [errors, setErrors] = useState([])
    const [showErrors, setShowErrors] = useState(false)
    const [openDatePicker, setOpenDatePicker] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showFailure, setShowFailure] = useState(false)

    const getLang = () => {
        const userLang = navigator.language || navigator.userLanguage;
        console.log("The language is: " + userLang);
        if (languageOptions.map(lang => lang.value).includes(userLang)) {
            setLanguage(languageOptions.filter(lang => lang.value === userLang)[0])
        } else {
            setLanguage({ label: 'English', value: 'en-US' },)
        }
    }
    const changeLanguage = (e) => {
        setLanguage(e)
    }
    const changeShop = async (e) => {
        const oldShop = selectedShop
        setSelectedShop(e)
        setValues(draft => { draft.dateTime = undefined })
        if (!closures.hasOwnProperty(e.value)) {
            const status = await getClosures(e.value)
            if (!status) {
                setSelectedShop(oldShop)
            }
        }

    }
    const getShop = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const shopID = urlParams.get('sID')
        if (shopID) {
            loadShops(shopID)
        }
    }
    const getClosures = async (ID) => {
        const resp = await fetch(`${globalContext.get.backendUrl}/crf/closures?shopID=${ID}`, {
            method: 'GET',
            credentials: 'include',
        })
        if (resp.status === 200) {
            const respValue = await resp.json()
            prepareClosures(ID, respValue.data)
            return true
        } else {
            return false
        }
    }
    const prepareClosures = (ID, closures) =>{
        Object.keys(closures).forEach(date=>{
            closures[date].forEach((hour, index)=>{
                const mHour=moment(hour, 'HH:mm')
                if(!['00','30'].includes(mHour.format('mm'))){
                    if(mHour.minutes()>=30){
                        closures[date][index]=mHour.add(1, 'hour').format('HH:00')
                    } else {
                        closures[date][index]=mHour.format('HH:30')
                    }
                }
            })
        })

        
        setClosures(draft => { draft[ID] = closures })
    }
    const loadShops = async (ID) => {
        const resp = await fetch(`${globalContext.get.backendUrl}/crf?shopID=${ID}`, {
            method: 'GET',
            credentials: 'include',
        })
        if (resp.status == 200) {
            const respValue = await resp.json()
            setShopOptions(respValue.data.shops)
            setCategoryOptions(respValue.data.categories.map(cat => ({ label: cat.cat_name, value: cat.ID })))
            const selected = respValue.data.shops.filter(sho => sho.value == ID)
            if (selected.length > 0) {
                setSelectedShop(selected[0])
            }
            getClosures(ID)
        }
    }
    const checkValidDate = (day) => {
        // console.log(closures)
        day=moment(day)
        if (closures[selectedShop.value]) {
            return Object.keys(closures[selectedShop.value]).includes(day.format('YYYY-MM-DD'))
        } else {
            return false
        }
    }
    const checkValidTime = (value, view) => {
        if(value){
           value=moment(value)
        if (closures[selectedShop.value] && closures[selectedShop.value][value.format('YYYY-MM-DD')]) {
            if (value.minute() < 30) {
                return closures[selectedShop.value][value.format('YYYY-MM-DD')].includes(value.format('HH:00'))
            } else {
                return closures[selectedShop.value][value.format('YYYY-MM-DD')].includes(value.format('HH:30'))
            }
        } 
        }
        
        return false
        // if (view == 'hours') {
        //     if (closures[selectedShop.value] && closures[selectedShop.value][value.format('YYYY-MM-DD')]) {
        //         return !(
        //             closures[selectedShop.value][value.format('YYYY-MM-DD')].includes(value.format('HH:00'))
        //             ||
        //             closures[selectedShop.value][value.format('YYYY-MM-DD')].includes(value.format('HH:30'))
        //         )
        //     }
        // } else if (view == 'minutes') {
            
        // }
    }
    const checkData = () => {
        setErrors([])
        let lerrors = []
        Object.keys(values).forEach(k => {
            setCheckValues(draft => { draft.good[k] = draft.check[k](values[k]) })
        })
        let isValid = true
        if (!privacyAccepted) {
            isValid = false
            lerrors = [text[language.value].privacy]
        }
        let pass = true
        Object.keys(checkValues.good).forEach(k => {
            pass = pass && checkValues.good[k]
        })
        if (!pass) {
            isValid = false
            lerrors = [...lerrors, text[language.value].correct_error]
        }
        if (!selectedCategory) {
            isValid = false
            lerrors = [...lerrors, text[language.value].category]
        }
        if (moment().diff(values.dateTime, 'minutes') > 0) {
            isValid = false
            lerrors = [...lerrors, text[language.value].date_hour]
        }
        if(values.dateTime){
            if(!checkValidDate(values.dateTime)||!checkValidTime(values.dateTime)){
                isValid = false
                setCheckValues(draft=>{draft.good.dateTime=false})
                lerrors = [...lerrors, text[language.value].date_hour]
            } else {
                setCheckValues(draft=>{draft.good.dateTime=true})
            }
        }
        if (isValid) {
            console.log('valid')
            addCustomerRequest()
        } else {
            console.log('!valid',lerrors)
            setErrors(lerrors)
            setShowErrors(true)
        }
    }
    const addCustomerRequest = async () => {
        const body = {
            cer_date: moment(values.dateTime).unix(),
            cer_name: values.name,
            cer_surname: values.surname,
            cer_prefix: values.prefix,
            cer_number: trim(values.number),
            cer_email: values.email,
            cer_notes: values.notes,
            Shop_ID: selectedShop.value,
            Category_ID: selectedCategory.value,
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/crf`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        if (resp.status == 200) {
            setShowSuccess(true)
        } else {
            setShowFailure(true)
        }
    }

    useEffect(() => {
        getShop()
        getLang()
    }, [])
    useEffect(()=>{
        if(selectedShop){
            if(selectedShop.phn_mandatory){
                setCheckValues(draft=>{
                    draft.check.number=(v) => { v = trim(v); return v.length > 7 && v.length <= 10 }
                    draft.check.prefix=(v) => { return v.length > 0 && v.length <= 4 }
                })
            } else {
                setCheckValues(draft=>{
                    draft.check.number=(v) => { v = trim(v); return (v.length > 7 && v.length <= 10) || v.length==0 }
                    draft.check.prefix=(v) => { return (v.length > 0 && v.length <= 4) || v.length==0 }
                })
            }
    
            if(selectedShop.email_mandatory){
                setCheckValues(draft=>{
                    draft.check.email=(v) => { return v && v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) }
                })
            } else {
                setCheckValues(draft=>{
                    draft.check.email=(v) => { return (v && v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) || v=='' }
                })
            }
        }
    },[selectedShop])


    return (
        <>
            <div className='crf-container'>
                <form className='crf-box'>
                    <p className='crf-header'>{text[language.value].title}</p>
                    <div className='crf-form-row'>
                        <p className='crf-label'>{text[language.value].select_language}</p>
                        <Select
                            id='select-pttp'
                            classNamePrefix='crf-'
                            components={animatedComponents}
                            options={languageOptions}
                            isSearchable={false}
                            value={language}
                            onChange={(e) => changeLanguage(e)}
                        />
                    </div>
                    <div className='crf-form-col  mt-4'>
                        <p className='crf-label'>{text[language.value].sede_apt} </p>
                        <Select
                            id='select-pttpr'
                            className='crf-shop-select'
                            classNamePrefix='crf-'
                            components={animatedComponents}
                            options={shopOptions}
                            value={selectedShop}
                            onChange={changeShop}
                        />
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].date_apt} </p>
                        <DatePicker
                            selected={values.dateTime}
                            onChange={(date) => {
                                setValues(draft => { draft.dateTime = date });
                                setCheckValues(draft => { draft.good.dateTime = draft.check.dateTime(date) })
                            }}
                            showTimeSelect
                            dateFormat="Pp"
                            locale={language.value} // Imposta la lingua per questo componente
                            minDate={moment().add(1, 'day').toDate()}
                            maxDate={moment().add(2, 'month').toDate()}
                            filterDate={checkValidDate} // Chiama la funzione per verificare se una data è disabilitata
                            filterTime={checkValidTime}
                            className={`crf-datepicker ${(!checkValues.good.name) && 'crf-input-error'}`}
                            onKeyDown={(e)=>e.preventDefault()}
                        />
                        {/* <ThemeProvider theme={theme}>
                            <button type='button' onClick={() => setOpenDatePicker(true)} className='crf-date-button'>
                                {values.dateTime ? `Data: ${values.dateTime.format('DD/MM/YYYY HH:mm')}` : text[language.value].select_date}
                            </button>
                            <DateTimePicker
                                // label="Data in cui vuole l'appuntamento: "
                                open={openDatePicker}
                                onClose={() => setOpenDatePicker(false)}
                                className='crf-datepicker'
                                viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                }}
                                ampm={false}
                                disablePast={true}
                                maxDate={moment().add(2, 'month')}
                                shouldDisableDate={checkValidDate}
                                shouldDisableTime={checkValidTime}
                                value={values.dateTime}
                                onChange={(date) => {
                                    setValues(draft => { draft.dateTime = date });
                                    setCheckValues(draft => { draft.good.dateTime = draft.check.dateTime(date) })
                                }}
                                format='DD/MM/YYYY HH:mm'
                                slotProps={{ textField: { size: '2vmax' } }}
                            />
                            <p className='crf-help-text'>{text[language.value].select_none}</p>
                            <p className='crf-help-text'>{text[language.value].time_desription}</p>
                        </ThemeProvider> */}
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].type_apt} </p>
                        <Select
                            id='select-pttpr'
                            className='crf-shop-select'
                            classNamePrefix='crf-'
                            components={animatedComponents}
                            options={categoryOptions}
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e)}
                        />
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].name}*</p>
                        <input
                            type='text'
                            placeholder='Matteo'
                            className={`crf-input-text ${(!checkValues.good.name) && 'crf-input-error'}`}
                            value={values.name}
                            maxLength={50}
                            onChange={(e) => {
                                setValues(draft => { draft.name = e.target.value });
                                setCheckValues(draft => { draft.good.name = draft.check.name(e.target.value) })
                            }}
                        />
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].surname} </p>
                        <input
                            type='text'
                            placeholder='Müller'
                            className={`crf-input-text ${(!checkValues.good.surname) && 'crf-input-error'}`}
                            value={values.surname}
                            maxLength={50}
                            onChange={(e) => {
                                setValues(draft => { draft.surname = e.target.value });
                                setCheckValues(draft => { draft.good.surname = draft.check.surname(e.target.value) })
                            }}
                        />
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].telephone}{selectedShop&&selectedShop.phn_mandatory?'*':''}</p>
                        <div className='crf-number-form'>
                            +
                            <input
                                type='text'
                                placeholder='41'
                                className={`crf-input-prefix ${(!checkValues.good.prefix) && 'crf-input-error'}`}
                                value={values.prefix}
                                maxLength={4}
                                onChange={(e) => {
                                    setValues(draft => { draft.prefix = e.target.value });
                                    setCheckValues(draft => { draft.good.prefix = draft.check.prefix(e.target.value) })
                                }}
                            />
                            <input
                                type='text'
                                placeholder='76 579 43 67'
                                className={`crf-input-number ${(!checkValues.good.number) && 'crf-input-error'}`}
                                value={values.number}
                                onChange={(e) => {
                                    setValues(draft => { draft.number = e.target.value });
                                    setCheckValues(draft => { draft.good.number = draft.check.number(e.target.value) })
                                }}
                            />
                        </div>
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].mail}{selectedShop&&selectedShop.email_mandatory?'*':''}</p>
                        <input
                            type='text'
                            placeholder='info@nacweb.ch'
                            className={`crf-input-text ${(!checkValues.good.email) && 'crf-input-error'}`}
                            value={values.email}
                            maxLength={50}
                            onChange={(e) => {
                                setValues(draft => { draft.email = e.target.value });
                                setCheckValues(draft => { draft.good.email = draft.check.email(e.target.value) })
                            }}
                        />
                    </div>
                    <div className='crf-form-col'>
                        <p className='crf-label'>{text[language.value].notee} </p>
                        <textarea
                            placeholder={text[language.value].note}
                            className={`crf-input-text-area ${(!checkValues.good.notes) && 'crf-input-error'}`}
                            value={values.notes}
                            maxLength={500}
                            onChange={(e) => {
                                setValues(draft => { draft.notes = e.target.value });
                                setCheckValues(draft => { draft.good.notes = draft.check.notes(e.target.value) })
                            }}
                        />
                    </div>
                    <div className='crf-form-row'>
                        <p className='crf-label' style={{ cursor: 'help', textDecoration: 'underline' }} onClick={() => { setShowPrivacy(true) }} >{text[language.value].pp}</p>
                        <div className='crf-check'>
                            <GoodCheck
                                defaultChecked={privacyAccepted}
                                onChange={(e) => setPrivacyAccepted(e.target.value)}
                                checkColor='#000'
                            />
                        </div>
                    </div>
                    <div className='crf-form-row crf-submit-row'>
                        <button
                            type='button'
                            className='crf-button'
                            // disabled={!privacyAccepted}
                            onClick={checkData}
                        >
                            Invia
                        </button>
                    </div>
                    <div className='crf-logo-row'>
                        <p className='login-image-nacweb'>Ideato e realizzato da</p>
                        <img
                            onClick={() => window.open('https://nacweb.ch', "_blank", "noreferrer")}
                            draggable={false}
                            onDragStart={false}
                            className='login-image-naclogo unselectable'
                            src={NACweblogo}
                        />
                    </div>
                </form>
            </div>
            <Modal className='crf-modal' show={showErrors} onHide={() => setShowErrors(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color privacy-policy-title'>{text[language.value].request_impossible}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p className='privacy-policy-text'>{text[language.value].correct}</p>
                    {errors.map(err => (
                        <p className='privacy-policy-text error-line'>{err}</p>
                    ))}
                </ModalBody>
            </Modal>
            <Modal className='crf-modal' show={showPrivacy} onHide={() => setShowPrivacy(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color privacy-policy-title'>{text[language.value].title_pp}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p className='privacy-policy-text' dangerouslySetInnerHTML={{ __html: text[language.value].description_pp }} />
                </ModalBody>
            </Modal>
            <Modal className='crf-modal' fullscreen={true} show={showSuccess} >
                <ModalHeader>
                    <ModalTitle className='nac-title light-color crf-succes-header'>{text[language.value].request_succ}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                   <p className='crf-succes-body'>{text[language.value].conf}</p> 
                   <p className='crf-succes-body'>{text[language.value].conf2}</p> 
                </ModalBody>
            </Modal>
            <Modal className='crf-modal' show={showFailure} onHide={() => setShowFailure(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color privacy-policy-title'>{text[language.value].imp}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                   <p className='privacy-policy-text'>{text[language.value].errore}</p> 
                </ModalBody>
            </Modal>
            <span className='privacy-box' onClick={() => { setShowPrivacy(true) }} >
                Privacy Policy
            </span>
        </>
    )
}

export default CustomerRequestForm